import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_USER, IS_DEMO } from 'config.js';

const initialState = {
  isLogin: IS_DEMO,
  currentUser: {},
  token: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCurrentUser(state, action) {
      console.log("Dispatched Payload:", action.payload);  // Debug Log
      state.currentUser = action.payload.user;
      state.token = action.payload.token;
      state.isLogin = true;
    },
    logout(state) {
      state.currentUser = {};
      state.token = null;
      state.isLogin = false;
    }
  },
});

export const { setCurrentUser, logout } = authSlice.actions;
const authReducer = authSlice.reducer;

export default authReducer;
